// extracted by mini-css-extract-plugin
module.exports = {"className":"he-IL_className__NrOjE"};